import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import { IndustryBuilderGuard } from "@/components/auth/IndustryBuilderGuard";
import HomeServicesProposalBuilder from "@/pages/HomeServicesProposalBuilder";
export const Route = createFileRoute("/home-services-builder")({ head: ({match}) => pageHead(match.pathname), component: () => (<ProtectedRoute><IndustryBuilderGuard industry="home-services"><HomeServicesProposalBuilder /></IndustryBuilderGuard></ProtectedRoute>) });
